import styled, { css } from 'styled-components';

interface TypographyProperties {
  $bold?: boolean;
  children?: any;
}

const getTypographyCSS = (tagName: string) => {
  return css`
    font-size: ${`var(--font-size-${tagName})`};
    line-height: ${`var(--line-height-${tagName})`};
    margin: 0 0 0 0;
    max-width: var(--max-line-length);
  `;
};

const ultraCSS = getTypographyCSS('ultra');
const h1CSS = getTypographyCSS('h1');
const h2CSS = getTypographyCSS('h2');
const h3CSS = getTypographyCSS('h3');
const h4CSS = getTypographyCSS('h4');
const h5CSS = getTypographyCSS('h5');
const pCSS = getTypographyCSS('p');
const smallCSS = getTypographyCSS('small');

export const H1 = styled.h1<TypographyProperties>`
  font-weight: 700;
  font-family: 'Fraunces', serif;
  letter-spacing: -0.03em;
  ${h1CSS}
`;

export const H2 = styled.h2<TypographyProperties>`
  font-weight: 700;
  font-family: 'Fraunces', serif;
  letter-spacing: -0.02em;
  ${h2CSS}
`;

export const H3 = styled.h3<TypographyProperties>`
  font-family: 'Fraunces', serif;
  font-weight: 700;
  color: var(--color-ink);
  letter-spacing: -0.02em;
  ${h3CSS}
`;

export const H4 = styled.h4<TypographyProperties>`
  font-weight: 700;
  font-family: 'Fraunces', serif;
  letter-spacing: -0.02em;
  ${h4CSS}
`;

export const H5 = styled.h5<TypographyProperties>`
  font-weight: 700;
  color: var(--color-ink);
  font-family: 'Fraunces', serif;
  letter-spacing: -0.01em;
  ${h5CSS}
`;

export const P = styled.p<TypographyProperties>`
  font-weight: ${(properties) => {
    return properties.$bold ? 'bold' : 'normal';
  }};
  font-family: 'Plus Jakarta Sans', sans-serif;
  color: var(--color-brown);
  ${pCSS}
`;

export const Small = styled.small<TypographyProperties>`
  font-weight: ${(properties) => {
    return properties.$bold ? '600' : 'normal';
  }};
  font-family: 'Plus Jakarta Sans', sans-serif;
  ${smallCSS}
  margin: 0;
`;

export const typographyCSS = css`
  .ultra {
    ${ultraCSS}
  }

  h1,
  .h1,
  .h1-b {
    font-weight: 700;
    font-family: 'Fraunces', serif;
    letter-spacing: -0.03em;
    ${h1CSS}
  }

  h2,
  .h2,
  .h2-b {
    font-weight: 700;
    font-family: 'Fraunces', serif;
    letter-spacing: -0.02em;
    ${h2CSS}
  }

  h3,
  .h3 {
    font-weight: 700;
    font-family: 'Fraunces', serif;
    letter-spacing: -0.02em;
    ${h3CSS}
  }

  h4,
  .h4,
  .h4-b {
    font-weight: normal;
    font-family: 'Fraunces', serif;
    ${h4CSS}
  }

  h5,
  .h5,
  .h5-b {
    font-weight: normal;
    font-family: 'Fraunces', serif;
    ${h5CSS}
  }

  p,
  .p,
  .p-b {
    ${pCSS}
    font-family: 'Plus Jakarta Sans', sans-serif;
    margin: 0 0 1rem 0;
  }

  small,
  .small,
  .small-b {
    ${smallCSS}
    margin: 0;
  }

  .h1-b,
  .h2-b,
  .h4-b,
  .h5-b,
  .p-b,
  .small-b {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
  }
`;
